import React from "react";
import { Entry } from "../models/entries";
import { UserJSON } from "../models/users";
import { EntryFinalResults } from "../models/entryfinalresults";
import { VoteJSON } from "../models/vote";
import { CompoCategoriesClient } from "../../../src/entity/CompoCategoriesClient";

export type EntryJudgeResultsWidgetProps = {
  entry: Entry;
  user: UserJSON | undefined;
  category_names: CompoCategoriesClient;
  results: EntryFinalResults;
  judge_votes: VoteJSON[];
};

export const EntryJudgeResultsWidget = ({
  judge_votes,
  category_names,
  results,
}: EntryJudgeResultsWidgetProps): JSX.Element => {
  if (!results) {
    return <div></div>;
  }

  return (
    <div className="flex flex-wrap gap-4">
      {judge_votes.map((vote, judgeIndex) => (
        <div
          key={judgeIndex}
          className="min-w-[180px] rounded border border-slate-200 bg-white p-3 shadow-sm"
        >
          <div className="text-[22px] font-bold">Judge {judgeIndex + 1}</div>

          {category_names.list.map((category_name, i) => (
            <div key={`${judgeIndex}-${category_name}`}>
              {category_name} {(vote as any)["custom" + (i + 1)]}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};